import { render, staticRenderFns } from "./QuoteEmail.vue?vue&type=template&id=dc65d83c"
import script from "./QuoteEmail.vue?vue&type=script&lang=js"
export * from "./QuoteEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports